// Helper — render filled/half/empty stars
function Stars({ rating }) {
  const stars = []
  for (let i = 1; i <= 5; i++) {
    if (rating >= i) {
      stars.push(<i key={i} className='fa fa-star'></i>)
    } else if (rating >= i - 0.5) {
      stars.push(<i key={i} className='fa fa-star-half-o'></i>)
    } else {
      stars.push(<i key={i} className='fa fa-star-o'></i>)
    }
  }
  return <span className='grating-stars'>{stars}</span>
}

export const Testimonials = (props) => {
  const offices = props.offices || []

  // Compute weighted aggregate from all offices
  const totalReviews = offices.reduce((s, o) => s + (o.reviewCount || 0), 0)
  const weightedSum  = offices.reduce((s, o) => s + (o.googleRating || 0) * (o.reviewCount || 0), 0)
  const aggRating    = totalReviews > 0 ? (weightedSum / totalReviews).toFixed(1) : null

  return (
    <div id='testimonials'>
      <div className='container'>
        <div className='section-title text-center'>
          <h2>What Our Customers Say</h2>
          <p>We love our customers! Don't take our word for it — hear what homeowners and businesses across India say about us.</p>
        </div>

        {/* ── Google Rating Banner ── */}
        {aggRating && (
          <div className='grating-banner'>
            {/* Aggregate score */}
            <div className='grating-aggregate'>
              <img
                src='https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png'
                alt='Google'
                className='grating-google-logo'
              />
              <div className='grating-score-wrap'>
                <span className='grating-score'>{aggRating}</span>
                <Stars rating={parseFloat(aggRating)} />
                <span className='grating-total'>
                  {totalReviews.toLocaleString('en-IN')} reviews across all offices
                </span>
              </div>
            </div>

            {/* Per-office chips */}
            <div className='grating-offices'>
              {offices.map((o, i) => (
                <a
                  key={i}
                  href={o.googleMapsLink}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='grating-chip'
                  title={`${o.city} — ${o.reviewCount} reviews`}
                >
                  <span className='grating-chip-city'>{o.city}</span>
                  <span className='grating-chip-score'>
                    <i className='fa fa-star'></i> {o.googleRating}
                  </span>
                  <span className='grating-chip-count'>({o.reviewCount})</span>
                </a>
              ))}
            </div>
          </div>
        )}

        {/* ── Customer quotes ── */}
        <div className='row'>
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className='col-md-4'>
                  <div className='testimonial'>
                    <div className='testimonial-image'>
                      <img src={d.img} alt='' />
                    </div>
                    <div className='testimonial-content'>
                      <Stars rating={5} />
                      <p>"{d.text}"</p>
                      <div className='testimonial-meta'>— {d.name}</div>
                    </div>
                  </div>
                </div>
              ))
            : 'loading'}
        </div>
      </div>
    </div>
  )
}
